import { render } from "./MyPopUpWindowHeader.vue?vue&type=template&id=76fd468e"
import script from "./MyPopUpWindowHeader.vue?vue&type=script&lang=js"
export * from "./MyPopUpWindowHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__